import Team03 from "./Team03";

function main() {
  return (
    <div>
      <Team03 />
    </div>
  );
}

export default main;
